<template>
  <div class="page">
    <div class="wrap">
      <el-card class="card" shadow="always">
        <div class="head">
          <div>
            <div class="title">你被邀请加入视频通话</div>
            <div class="sub">点击“进入房间”后将加入 TRTC 视频通话。</div>
          </div>
          <el-tag effect="light" type="info">Invite</el-tag>
        </div>

        <el-divider />

        <TrtcRoom
          type="invite"
          :sdkAppId="Number(sdkAppId)"
          :inviteUserSig="userSig"
          :userId="userId"
          :strRoomId="strRoomId"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import TrtcRoom from "@/components/trtc/CompRoom.vue";

export default {
  name: "InvitePage",
  components: { TrtcRoom },
  computed: {
    sdkAppId() {
      return this.$route.query.sdkAppId || "";
    },
    userSig() {
      return this.$route.query.userSig || "";
    },
    userId() {
      return this.$route.query.userId || "";
    },
    strRoomId() {
      return this.$route.query.strRoomId || "";
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100%;
  padding: 18px 16px 26px;
}
.wrap {
  max-width: 1100px;
  margin: 0 auto;
}
.card {
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.92);
  color: #111827;
}
.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}
.title {
  font-size: 18px;
  font-weight: 900;
}
.sub {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
</style>

